import React from 'react';
import {get} from 'lodash';
import className from 'classnames';
import moment from 'moment';

import {
  searchkickDisabled,
} from '../lib/helpers';

import {useCheckIds} from '../hooks';

import OverflowH from './OverflowH';
import DotTooltip from './DotTooltip';
import TableHeader from './TableHeader';
import ImageLoader from './ImageLoader';

const UserReportLists = ({
  reports = [],
  total = 0,
}) => {
  const {
    checkIds,
    renderCheckBox, renderCheckBoxForCheckAll,
    renderOpenAllButton,
  } = useCheckIds({
    data: reports,
    openUrl: 'reports',
  })

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>User reports</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} reports</p>
        </div>

        {renderOpenAllButton()}
      </div>

      <div className='TableChecker'>
        {renderCheckBoxForCheckAll()}
      </div>

      <div className='Table Table--user-report-list'>
        {(() => {
          let columnHeaders = [
            {
              label: '',
            },
            {
              label: 'ID',
              sortKey: 'report_id',
            },
            {
              label: 'Report From',
              sortKey: 'user_id',
            },
            {
              label: 'Report From Birthday (Age)'
            },
            {
              label: 'Report to',
              sortKey: 'reportable_id',
            },
            {
              label: 'Reason',
            },
            {
              label: 'Profile icon',
            },
            {
              label: 'Reported count',
              sortKey: 'reportable_reported_count',
            },
          ]

          if (searchkickDisabled()) {
            columnHeaders = [
              ...columnHeaders,
              {
              label: 'Blocked count',
            },
            ]
          } else {
            columnHeaders = [
              ...columnHeaders,
              {
                label: 'Blocked count',
                sortKey: 'reportable_blocked_count',
              },
            ]
          }

          columnHeaders = [
            ...columnHeaders,
            {
              label: 'Biography',
            },
            {
              label: 'UUID',
            },
            {
              label: 'Created date',
              sortKey: 'created_at',
            },
            {
              label: 'Status',
              sortKey: 'checked_at',
            },
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {reports.map((report) => (
          <div
            className={className('Table__row', {
              'Table__row--active': checkIds.includes(report.id),
            })}
            key={report.id}
            data-x={report}
          >
            <div className='Table__col'>
              {renderCheckBox(report)}
            </div>

            <div className='Table__col'>
              <a
                className='Table__a'
                href={`/${gon.currentProvider}/reports/${report.id}`}
              >
                {report.id}
              </a>
            </div>

            <div className='Table__col'>
              <DotTooltip
                user={report.user}
              />
            </div>

            <div className='Table__col'>
              {report.user.birthDate &&
                <span>{moment(report.user.birthDate).format('YYYY-MM-DD')} ({get(report, 'user.age', 'N/A')})</span>
              }
            </div>

            <div className='Table__col'>
              <DotTooltip
                user={report.reportable}
              />
            </div>

            <div className='Table__col'>
              <OverflowH
                controlWidth
                text={report.reason}
              />
            </div>

            <div className='Table__col'>
              <div className='ImageBorder'>
                <ImageLoader
                  url={get(report, 'reportable.profileIcon.thumb.url')}
                />
              </div>
            </div>

            <div className='Table__col'>{get(report, 'reportable.reportedCount', 0)}</div>
            <div className='Table__col'>{get(report, 'reportable.blockedByCount', 0)}</div>

            <div className='Table__col'>
              <OverflowH
                text={get(report, 'reportable.biography')}
              />
            </div>

            <div className='Table__col'>{get(report, 'reportable.uuid')}</div>

            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: report.createdAt !== null ?
                    moment(report.createdAt).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />

            <div className='Table__col'>
              {report.checkedAt === undefined ?
                <span className='Badge Badge--gray'>N/A</span>
              :
                <React.Fragment>
                  {report.checkedAt !== null ?
                    <span className='Badge'>CHECKED</span>
                  :
                    <span className='Badge Badge--orange'>PENDING</span>
                  }
                </React.Fragment>
              }
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default UserReportLists;
